import React from 'react';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/solid';

const PlanDetailModal = ({ isOpen, onClose, plan }) => {
    if (!isOpen || !plan) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg w-4/5 max-w-3xl shadow-lg max-h-screen overflow-y-auto">
                {/* Modal Header */}
                <div className="flex justify-between items-center bg-gray-200 px-4 py-2 rounded-t-lg">
                    <h2 className="text-xl font-bold">{plan.title} Details</h2>
                    <button
                        onClick={onClose}
                        className="text-red-600 hover:text-gray-900 text-2xl font-bold"
                    >
                        &times;
                    </button>
                </div>

                {/* Modal Content */}
                <div className="p-6">
                    {/* Plan Details Section */}
                    <div className="mt-4">
                        <h4 className="text-xl font-semibold mb-2">Plan Details</h4>
                        <div className="grid grid-cols-2 gap-4">
                            <div><strong>MRP: </strong> {plan.mrp}</div>
                            <div><strong>Price: </strong> {plan.price}</div>
                            <div><strong>Suggested: </strong> {plan.isSuggested ? 'Yes' : 'No'}</div>
                            <div><strong>Description: </strong> {plan.description}</div>
                        </div>
                    </div>

                    {/* Features List Section */}
                    <div className="mt-4">
                        <h4 className="text-xl font-semibold mb-2">Features</h4>
                        <ul className="list-disc ml-6">
                            {plan.list.map((feature, index) => (
                                <li key={index} className="flex items-center gap-2 mb-2">
                                    {feature.inPlan ? (
                                        <CheckCircleIcon className="h-6 w-6 text-green-500" />
                                    ) : (
                                        <XCircleIcon className="h-6 w-6 text-red-500" />
                                    )}
                                    <span className={feature.inPlan ? 'text-black' : 'text-gray-500'}>
                                        {feature.text}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Close Button */}
                    <div className="mt-6 flex justify-end">
                        <button onClick={onClose} className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlanDetailModal;